
import { computed, defineComponent, ref, SetupContext } from 'vue';

export default defineComponent({
  name: 'TSlogan',
  components: {},
  emits: ['click'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-slogan');
    /** 模板依赖的className */
    const getClasses = computed(() => {
      return {
        wrap: [prefixCls.value],
        logo: [`${prefixCls.value}-logo`],
        name: [`${prefixCls.value}-name`],
      };
    });
    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);

    return { prefixCls, getClasses, listener };
  },
});
